import { call, put, takeLatest } from "redux-saga/effects";
import fetchAPI, { ApiResponse } from "../../../utils/api";
import loginPageSlice from "../../login-page/store/slice";
import vehicleTypeSlice, { VehicleType } from "./slice";

type VehicleTypeResponse = ApiResponse<{ data: VehicleType[] }>;

function* vehicleTypeSaga() {
  yield takeLatest(loginPageSlice.actions.setLoggedIn, handleFetch);
}

function* handleFetch() {
  const response: VehicleTypeResponse = yield call(fetchAPI, "/vehicle-types");

  if (response && response.data) {
    yield put(vehicleTypeSlice.actions.setData(response.data));
  }

  yield put(vehicleTypeSlice.actions.setIsLoading(false));
}

export default vehicleTypeSaga;
